export const MODAL_CONSTANTS = {
    PARAM_SRC: "modal",
    PARAM_SIZE: "modalSize",
    PARAM_PLACEMENT: "modalPlacement",
} as const;
